import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import "./faq.css";
import config from "../../config";
export default function Faq() {
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const navigate = useNavigate();

  // if (!loginDetails) {
  //   navigate(`${config.baseUrl}`);
  //   window.scrollTo(0,0)
  // }
  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="faq py-4 mb-5 bgStar">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <div className="text-center pt-5 pb-3">
                    <div
                      className="headingbox position-relative mb-5"
                    // style={{ minHeight: "100px" }}
                    >
                      <div className="coins">
                        <img
                          src={`${config.baseUrl}images/coinsmall.png`}
                          className="position-absolute start-0 bottom-0"
                          style={{ width: "70px" }}
                          alt=""
                        />
                        <img
                          src={`${config.baseUrl}images/coinlarge.png`}
                          className="position-absolute end-0 top-0"
                          style={{ width: "90px" }}
                          alt=""
                        />
                      </div>
                      <div className="position-relative d-inline-block text-left">
                        <div className="polygon" style={{ right: "-78px" }}>
                          <img
                            src={`${config.baseUrl}images/shape/polygon.png`}
                            alt=""
                          />
                        </div>
                        <h1 className=" position-relative text-white">
                          Frequently Asked Questions (FAQS)
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-style mt-4">
                    <Accordion defaultActiveKey={["0"]}>
                      <Accordion.Item eventKey="0" className="mb-3">
                        <Accordion.Header>
                          What is the ©SbSe Protocol?{" "}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>The <b>SbSe Protocol</b> is a smart, community-governed engine that powers the entire INFI ecosystem.
                            All actions — from transactions to governance — are executed via permission-less smart contracts
                            based on the decisions of INFI holders.</p>
                          <p className="mb-0">
                            <b>Use responsibly —</b> the platform is decentralized and irreversible once actions are confirmed on
                            the blockchain.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1" className="mb-3">
                        <Accordion.Header>
                          Which blockchains are supported by INFI Launchpad and
                          INFI MultiChain CDEX?{" "}
                        </Accordion.Header>
                        <Accordion.Body>
                          The INFI ecosystem currently supports <b>13 blockchains,</b> with more <b>integrations coming soon.</b>
                          You're free to launch and trade cross-chain, easily and seamlessly
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2" className="mb-3">
                        <Accordion.Header>
                          Are there listing or fundraising fees?
                        </Accordion.Header>
                        <Accordion.Body>
                          <strong>No!</strong>
                          <br />
                          INFI Launchpad and INFI MultiChain CDEX are free to use — there are zero listing or fundraising fees.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3" className="mb-3">
                        <Accordion.Header>
                          How do I interact with the platform?
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            <li className="mb-2">The platform is non-custodial — it never holds your assets or private keys.</li>
                            <li className="mb-2">You must use your own cold wallet to interact.</li>
                          </ul>
                          <p className="mb-0"> <b>Your wallet,</b> your funds. Full control remains with you at all times.</p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="4" className="mb-3">
                        <Accordion.Header>
                          Are there crypto-to-fiat services?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p><b>No.</b></p>
                          The INFI ecosystem is purely crypto-native and does not handle fiat currencies.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="5" className="mb-3">
                        <Accordion.Header>
                          How are trading fees and rewards calculated?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>Fees are calculated by the SbSe Protocol's smart contracts. They are:</p>
                          <ul>
                            <li className="mb-2">Transparent during trades</li>
                            <li>Automatically distributed to:
                              <ul className="mt-2">
                                <li className="mb-2">SbSe PFP Pool</li>
                                <li className="mb-2">SbSe Reserve</li>
                                <li className="mb-2">SbSe Treasury</li>
                                <li>SbSe INFI Reserve</li>
                              </ul>
                            </li>
                          </ul>
                          <p className="mb-0">Only INFI stakers control these pools — no centralized party is involved.</p>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="6" className="mb-3">
                        <Accordion.Header>
                          Can I trade any amount?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>Yes. But if a sell causes more than 1% price impact, the protocol will:</p>
                          <ul>
                            <li className="mb-2">Apply an extra fee</li>
                            <li className="mb-2">Send it to the SbSe Reserve Pool</li>
                            <li>Activate the 48-hour compensation mechanism if needed</li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="7" className="mb-3">
                        <Accordion.Header>
                          What is Special Liquidity Management (SpecialLM) and
                          why is it required?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>SpecialLM ensures:</p>
                          <ul>
                            <li className="mb-2">Liquidity protection</li>
                            <li className="mb-2">Transaction integrity</li>
                            <li>Buyer safety</li>
                          </ul>
                          <p className="mb-0">It’s mandatory for all projects using the INFI Launchpad. It also powers the <b>48-hour scam protection plan.</b></p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="8" className="mb-3">
                        <Accordion.Header>
                          Do I need KYC or audit?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="mb-2"><b>No.</b></p> The platform is 100% decentralized. We do not collect any user data.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="9" className="mb-3">
                        <Accordion.Header>
                          Are traders rewarded?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="mb-2">Yes!</p>
                          <p className="mb-0">Every trade earns automatic incentives, sent directly to your wallet by the SbSe Protocol.</p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="10" className="mb-3">
                        <Accordion.Header>
                          Why should I stake INFI?

                        </Accordion.Header>
                        <Accordion.Body>
                          <p>By staking INFI (minimum 1,000 INFI):</p>

                          <ul class="list-unstyled mb-3">
                            <li>• You <strong>gain voting rights</strong> in the DAO</li>
                            <li>• Help manage treasury pools</li>
                            <li>• May receive <strong>monthly rewards</strong> if fees were collected</li>
                          </ul>

                          <p class="mb-0">
                            <small>
                              Reminder: INFI is a <strong>utility token</strong>, not a financial instrument.
                              No guaranteed profits.
                            </small>
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="20" className="mb-3">
                        <Accordion.Header>
                          Is INFI Multichain CDEX centralized?
                        </Accordion.Header>
                        <Accordion.Body>

                          <p className="mb-0">No — it’s <b>fully decentralized</b> and governed by INFI holders. All functions run via smart contracts.</p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="11" className="mb-3">
                        <Accordion.Header>
                          How long is the staking period?
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            <li className="mb-2">Fixed at <b>24 months</b></li>
                            <li>After that, you can:

                              <ul className="mt-2">
                                <li className="mb-2">Claim manually</li>
                                <li className="mb-2">Re-stake manually</li>
                                <li>Or do nothing — the protocol will auto re-stake your tokens</li>

                              </ul>
                            </li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="12" className="mb-3">
                        <Accordion.Header>
                          When can I claim rewards?
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            <li className="mb-2">From the 1st to 25th of each month (if rewards exist)</li>
                            <li>Staking is open from 26th to 29th each month</li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="13" className="mb-3">
                        <Accordion.Header>
                          What if I don’t claim rewards?
                        </Accordion.Header>
                        <Accordion.Body>
                          They’ll roll over automatically into next month’s reward allocation.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="14" className="mb-3">
                        <Accordion.Header>
                          Will INFI be listed on other exchanges?
                        </Accordion.Header>
                        <Accordion.Body>
                          No. INFI is exclusive to the INFI MultiChain CDEX.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="15" className="mb-3">
                        <Accordion.Header>
                          Will anyone ever contact me for wallet keys?
                        </Accordion.Header>
                        <Accordion.Body>
                          <p><b>Never!</b></p>
                          <p>There is no central team. The ecosystem is powered by the community and DAO</p>
                          <p>Never share your wallet seed phrase or private key.</p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="16" className="mb-3">
                        <Accordion.Header>
                          How does delisting work?
                        </Accordion.Header>
                        <Accordion.Body>

                          <div>
                            <p>After the lock-up ends:</p>
                            <ul className="list-unstyled">
                              <li>
                                Only project owners can propose delisting via DAO vote
                              </li>
                              <li>
                                If passed, they can delist with a 5% fee sent to the SbSe Treasury
                              </li>
                            </ul>
                            Voting eligibility: 1,000–12,000 staked INFI per wallet
                            One wallet = One vote
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="17" className="mb-3">
                        <Accordion.Header>
                          Can project owners remove liquidity?
                        </Accordion.Header>
                        <Accordion.Body>

                          <div>
                            <p>Yes, but only after the lock-up period (2 months to 20 years).
                              After that:</p>
                            <ul className="list-unstyled">
                              <li className="mb-2">
                                Liquidity can be removed freely
                              </li>
                              <li>
                                But 60% of the withdrawn liquidity is sent to the SbSe Reserve to protect investors
                              </li>
                            </ul>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="18" className="mb-3">
                        <Accordion.Header>
                          What if I’m scammed?
                        </Accordion.Header>
                        <Accordion.Body>
                          <div>
                            <p>Raise a fraud proposal via the DAO</p>
                            <p>Only voters with 1,000+ staked INFI can vote on fraud cases.</p>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="19" className="mb-3">
                        <Accordion.Header>
                          How do I raise funds or contribute via INFI Launchpad?
                        </Accordion.Header>
                        <Accordion.Body>

                          <div>
                            <p><b>Project Owners:</b></p>
                            <ul className="list-unstyled">
                              <li className="mb-2">
                                Choose Single-Stage or Multi-Stage launches
                              </li>
                              <li className="mb-2">
                                In Multi-Stage, liquidity is reserved before advancing to the next stage
                                Contributors:
                              </li>
                              <li className="mb-2">Claim refunds if the soft cap isn't met</li>
                              <li>All contributions are governed by the protocol automatically</li>
                            </ul>

                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="20" className="mb-3">
                        <Accordion.Header>
                          Is there a disclaimer?
                        </Accordion.Header>
                        <Accordion.Body>

                          <div>
                            <p><b>Yes — but remember:</b></p>
                            The platform is governed by permissionless smart contracts.
                            It offers no guarantees, refunds, or centralized support.
                            Always read the full Disclaimer before participating.

                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
